// src/user/components/modals/ConfirmStartModal.jsx
import React, { useEffect } from 'react';

export default function ConfirmStartModal({
  show,
  title = 'Confirm Task Start',
  message = 'Are you at the site, ready to start working on this task?',
  confirmLabel = 'Yes, Start Task',
  cancelLabel = 'Cancel',
  onConfirm,
  onCancel,
  isLoading = false,
}) {
  // Always call hooks; guard the side effects inside
  useEffect(() => {
    if (!show) return;

    const onKey = (e) => e.key === 'Escape' && onCancel?.();
    document.addEventListener('keydown', onKey);
    document.body.classList.add('modal-open');

    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.classList.remove('modal-open');
    };
  }, [show, onCancel]);

  if (!show) return null;


  return (
    <div
      className="modal fade show d-block"
      role="dialog"
      aria-modal="true"
    >
      <div className="modal-dialog" onMouseDown={(e) => e.stopPropagation()}>
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{title}</h5>
            <button type="button" className="btn-close" aria-label="Close" onClick={onCancel} />
          </div>
          <div className="modal-body">
            <p className="mb-0">{message}</p>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onCancel} disabled={isLoading}>
              {cancelLabel}
            </button>
            <button type="button" className="btn btn-primary" onClick={onConfirm} disabled={isLoading}>
              {isLoading ? 'Starting...' : confirmLabel}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
